import type { FacilityId } from '@gyym/sdk'
import { useGyymClient, useGyymSWR } from '@gyym/sdk-react'

export const useFacility = (facilityId: FacilityId) => {
  const client = useGyymClient()
  return useGyymSWR([client.user.facilities.get, facilityId])
}
